import React, { useEffect, useState } from "react";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import {
  DeleteOnedata,
  getDataWithFilterUrl,
} from "../../controllers/APIController";
import LoadingPage from "../../components/Loader/LoadingPage";
import {
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@nextui-org/react";
import NullData from "../../components/ErrorPage/NullData";
import { useNavigate } from "react-router-dom";
import { LeftArrow } from "../../Images/LeftArrow";
import { DeleteTableItem, formatDate, UserCell } from "../../utils/helper";

const InviteRequest = () => {
  const [invitationList, setInvitationList] = useState([]);
  const [Loader, setLoader] = useState(true);
  const [reRenderPage, setReRenderPage] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();

  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;

  const deleteInvitationHandler = async (id) => {
    const deleteResponse = await DeleteOnedata("invitations", id);
    setReRenderPage((pre) => !pre);
  };

  useEffect(() => {
    getDataWithFilterUrl(
      "invitations",
      `filters[organization][id][$eqi]=${OrgInfo}`
    ).then((data) => {
      setInvitationList(data?.data);
      setLoader(false);
    });
  }, [reRenderPage]);

  const ItemPerPage = 20;
  const totalPage = Math.ceil(invitationList?.length / ItemPerPage);


  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-white border-b border-slate-200 px-8 py-6 shadow-sm">
        <div className="flex items-center gap-4 max-w-full">
          <span
            className="cursor-pointer hover:opacity-70 text-slate-600 hover:text-slate-900 transition-colors"
            onClick={() => navigate("/default/user-management")}
          >
            <LeftArrow height={28} width={20} />
          </span>
          <div>
            <h1 className="text-2xl font-semibold text-slate-900">Invite Requests</h1>
            <p className="text-sm text-slate-600 mt-1">View and manage account invitations made by organization</p>
          </div>
        </div>
      </div>

      <BreadCrumbsPage>
        <div className="max-w-7xl mx-auto px-8 py-8">
          <LoadingPage isLoading={Loader} loadingText="Loading invite requests...">
            {/* Invitations Table */}
            <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
              <div className="px-6 py-4 border-b border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900">Pending Invitations</h3>
                <p className="text-sm text-slate-600 mt-1">Manage and review invitation requests</p>
              </div>
              <Table 
                removeWrapper 
                aria-label="Invitation requests table"
                classNames={{
                  th: "bg-slate-50 text-slate-700 font-medium",
                  td: "py-4",
                }}
              >
            <TableHeader>
              <TableColumn>User Email</TableColumn>
              <TableColumn>Status</TableColumn>
              <TableColumn>Date</TableColumn>
              <TableColumn>Send By</TableColumn>
              <TableColumn>Action</TableColumn>
            </TableHeader>
            <TableBody
              emptyContent={<NullData title={"No Invitation found"} />}
            >
              {invitationList &&
                invitationList.map((item, index) => {
                  const email = item?.attributes?.email;
                  const sendByEmail =
                    item?.attributes?.sendBy?.data?.attributes?.email;
                  const sendByavatarUrl =
                    item?.attributes?.sendBy?.data?.attributes
                      ?.ProfilePictureUrl;
                  const sendById = item?.attributes?.sendBy?.data?.id;
                  const currentStatus = item?.attributes?.Status;
                  const createdAt = formatDate(item?.attributes?.createdAt);

                  return (
                    <TableRow key={index}>
                      <TableCell>{email}</TableCell>
                      <TableCell>{currentStatus}</TableCell>
                      <TableCell>{createdAt}</TableCell>
                      {UserCell(sendByEmail, sendById, sendByavatarUrl)}
                      <TableCell>
                        <DeleteTableItem
                          userRole={"Admin"}
                          deleteHandler={deleteInvitationHandler}
                          item={item}
                          toolTiptext="Delete Invitation"
                          DropDownText={`Delete ${email} invitation`}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          
          {invitationList?.length > 0 && (
            <div className="flex items-center justify-center p-6 border-t border-slate-200">
              <Pagination
                showControls
                total={totalPage}
                color="primary"
                page={currentPage}
                onChange={setCurrentPage}
                classNames={{
                  item: "bg-transparent hover:bg-slate-100",
                  cursor: "bg-emerald-600 text-white",
                }}
              />
            </div>
          )}
            </div>
          </LoadingPage>
        </div>
      </BreadCrumbsPage>
    </div>
  );
};

export default InviteRequest;
